export const USER_UPDATED = 'USER_UPDATED';
export const SEND_MESSAGE_START = 'SEND_MESSAGE_START';
export const SEND_USER_MESSAGE = 'SEND_USER_MESSAGE';
export const SEND_FILE_MESSAGE = 'SEND_FILE_MESSAGE';
export const UPDATE_USER_MESSAGE = 'UPDATE_USER_MESSAGE';
export const DELETE_MESSAGE = 'DELETE_MESSAGE';
export const LEAVE_CHANNEL = 'LEAVE_CHANNEL';
export const CREATE_CHANNEL = 'CREATE_CHANNEL';
